import { ThemeUIStyleObject } from "theme-ui"

export const heroStyle: ThemeUIStyleObject = {
  height: ["calc(100vh - 100px)", "760px"],
  overflow: "hidden",
  position: "relative",
}

export const heroRatioStyle: ThemeUIStyleObject = {
  height: "100%",
  position: "relative",
  backgroundColor: "brownMedium",
  backgroundSize: "cover",
  backgroundPosition: "top center",
}

export const heroContentStyles: ThemeUIStyleObject = {
  position: "relative",
  zIndex: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
  height: "100%",
  textAlign: "center",
}

export const headingStyle: ThemeUIStyleObject = {
  fontSize: ["h2", "h1"],
}
